<script setup lang="ts">
defineProps({
  hasFunds: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const userStore = useUserStore();
const GFALExStore = useGFALExStore();
const { trackEvent } = useGAnalytics();
const isModalOnRampShown = ref<boolean>(false);
</script>

<template>
  <div class="gfal-wallet-card relative h-[216px] mt-4 p-4 flex flex-col">
    <div
      class="text-neutral-200 flex justify-between items-baseline gap-2 flex-wrap">
      <h1 class="text-neutral-200 font-bold text-xl">
        {{ $t("main.gfalWallet.gfalWallet") }}
      </h1>
    </div>
    <div class="mt-2 mb-6" :class="{ 'h-full': !userStore.accountAddress }">
      <div
        v-if="userStore.accountAddress"
        class="w-full h-full text-neutral-200 flex items-start justify-between">
        <p v-if="userStore.accountAddress">
          {{ $t("main.gfalWallet.balance") }}
        </p>
        <div>
          <p class="text-neutral-200 font-bold">
            {{ roundNum(userStore.balance ?? 0) }}
            GFAL
          </p>
          <p class="text-xs text-right">
            ~
            {{ roundNum(GFALExStore.GFALExRate * (userStore.balance ?? 0)) }}
            USD
          </p>
        </div>
      </div>
      <div v-else class="w-full h-full flex flex-col gap-4">
        <p class="text-neutral-300">
          {{ $t("main.gfalWallet.noWallet") }}
        </p>
        <button
          id="create_gfal_wallet_button"
          data-test="button-create-gfal-wallet"
          class="text-neutral-200 font-bold px-4 py-1 border-2 border-main-500 rounded-sm self-end mt-auto mb-2"
          @click="trackEvent('create_gfal_wallet_button')">
          <NuxtLinkLocale to="/user-portal/dashboard">
            {{ $t("main.gfalWallet.createWallet") }}
          </NuxtLinkLocale>
        </button>
      </div>
    </div>
    <div
      v-if="userStore.accountAddress && !hasFunds"
      class="flex flex-col justify-between gap-4 mt-auto mb-2">
      <div class="flex gap-2">
        <BaseIconPayment name="visa" />
        <BaseIconPayment name="mastercard" />
        <BaseIconPayment name="apple" />
        <BaseIconPayment name="google" />
        <BaseIconPayment name="revolut" />
        <BaseIconPayment name="sepa" />
        <BaseIconPayment name="ach" />
      </div>
      <button
        id="add_funds_button"
        data-test="button-add-funds"
        class="text-neutral-200 font-bold px-11 py-1 border-2 border-main-500 rounded-sm"
        @click="(isModalOnRampShown = true), trackEvent('add_funds_button')">
        {{ $t("main.gfalWallet.addFunds") }}
      </button>
    </div>

    <!-- Logo bottom-right using BaseIcon -->
    <BaseIcon
      name="GFAL_token_gray"
      class="absolute bottom-3 right-3 w-10 h-10 opacity-40 pointer-events-none select-none" />
  </div>

  <ModalOnRamp v-if="isModalOnRampShown" @close="isModalOnRampShown = false" />
</template>